import { Navigate, Route, Routes } from 'react-router-dom';
import { ProductDashboard } from 'pages/insights-pro/product-tab/ProductDashboard';
import { TopReturnedProducts } from 'pages/insights-pro/product-tab/reports/top-returned-products/TopReturnedProducts';
import { TopSellingProducts } from 'pages/insights-pro/product-tab/reports/top-selling-products/TopSellingProducts';

export function ProductRoutes() {
  return (
    <Routes>
      <Route index element={<ProductDashboard />} />
      <Route path="reports/returns" element={<TopReturnedProducts />} />
      <Route path="reports/top-selling" element={<TopSellingProducts />} />
      <Route path="*" element={<Navigate to="" />} />
    </Routes>
  );
}
